import React, { FC, Fragment } from 'react'
import styled from 'styled-components'

import type { EmptyStateWithIconProps } from './EmptyState.types'

import { Stack, Group } from 'components/Layout'
import Text from 'components/Text/Text'
import Button from 'components/Button/Button'

const VerticalWrapper = styled(Stack)`
  text-align: center;
`

const EmptyStateWithIcon: FC<EmptyStateWithIconProps> = ({
  variant = 'card',
  icon,
  title,
  action,
  children,
  ...props
}: EmptyStateWithIconProps) => {
  const isHorizontal = variant === 'horizontal-card'
  const Wrapper = isHorizontal ? Group : VerticalWrapper

  return (
    <Wrapper {...props} space={isHorizontal ? 's' : 'xs'} align="center" justify="center">
      {children || (
        <Fragment>
          {icon}
          <Text variant="caption-bold">{title}</Text>
          {action && (
            <Button variant="primary" scale="small" {...action}>
              {action.label}
            </Button>
          )}
        </Fragment>
      )}
    </Wrapper>
  )
}

export default EmptyStateWithIcon
